import Vue from 'vue'

const state = {
    result: {}
}

const getters = {
    getResult: state =>{
        return state.result
    },
}

const actions = {
    setResult({commit}, result) {
        commit('setResult', result)
    }
}

const mutations = {
    setResult(state, payload){
        Object.keys(payload).forEach(key => {
            Vue.set(state.result, key, payload[key])
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}